import { memo } from 'react';
import { useLocation, Redirect, generatePath } from 'react-router-dom';
import { useCurrentPageType } from '../../../views/hooks/useCurrentPageType';
import { useCurrentViewId } from '../../../views/hooks/useCurrentViewId';
import { useSelectedObjectTypeId } from '../../../objectTypeIdContext/hooks/useSelectedObjectTypeId';
import { LIST } from '../../../views/constants/PageType';
import { ALL } from '../../../views/constants/DefaultViews';
import { useDefaultViewId } from '../../defaultView/hooks/useDefaultViewId';
import { getMostRecentlyUsedPageType } from '../../../app/utils/mostRecentlyUsedPageType';
import IndexPageContainer from './IndexPageContainer';
import { useAvailableObjectTypes } from '../../../crmObjects/hooks/useAvailableObjectTypes';
import { UnavailableObjectTypeError } from '../../../errorBoundary/UnavailableObjectTypeError';
import { useSupportedVisualizations } from '../../../viz/hooks/useSupportedVisualizations';
import { jsx as _jsx } from "react/jsx-runtime";
const getTargetPageType = ({
  currentPageType,
  objectTypeId,
  supportedVisualizations
}) => {
  if (currentPageType && supportedVisualizations.has(currentPageType)) {
    return currentPageType;
  }
  const mostRecentlyUsedPageType = getMostRecentlyUsedPageType(objectTypeId);
  if (mostRecentlyUsedPageType && supportedVisualizations.has(mostRecentlyUsedPageType)) {
    return mostRecentlyUsedPageType;
  }
  return LIST;
};

// Exported for testing purposes
export const IndexViewRedirect = () => {
  const supportedVisualizations = useSupportedVisualizations();
  const availableObjectTypes = useAvailableObjectTypes();
  const objectTypeId = useSelectedObjectTypeId();
  const isIndexPageEnabledForObjectType = availableObjectTypes.has(objectTypeId);
  const currentViewId = useCurrentViewId();
  const defaultViewId = useDefaultViewId({
    objectTypeId,
    viewId: currentViewId,
    skip: Boolean(currentViewId)
  });
  const currentPageType = useCurrentPageType();
  const targetViewId = currentViewId || defaultViewId || ALL;
  const targetPageType = getTargetPageType({
    currentPageType,
    objectTypeId,
    supportedVisualizations
  });
  const currentLocation = useLocation();
  if (!isIndexPageEnabledForObjectType) {
    return /*#__PURE__*/_jsx(UnavailableObjectTypeError, {
      objectTypeId: objectTypeId
    });
  }
  if (targetViewId !== currentViewId || targetPageType !== currentPageType) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: Object.assign({}, currentLocation, {
        pathname: generatePath('/objects/:objectTypeId/views/:viewId/:pageType', {
          objectTypeId,
          viewId: targetViewId,
          pageType: targetPageType
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(IndexPageContainer, {});
};
export default /*#__PURE__*/memo(IndexViewRedirect);